import React, { useEffect, useRef, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, networkError, token } = useAuth();
  const [showTimeout, setShowTimeout] = useState(false);
  const timerRef = useRef(null);
  const wasLoadingRef = useRef(loading);

  // iOS Fix: Show timeout message after 5 seconds of loading
  useEffect(() => {
    // Clear any existing timer first
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    
    if (loading) {
      wasLoadingRef.current = true;
      timerRef.current = setTimeout(() => {
        setShowTimeout(true);
      }, 5000);
    } else if (wasLoadingRef.current) {
      // Loading just finished - reset timeout state via ref check
      wasLoadingRef.current = false;
      // Use setTimeout(0) to avoid synchronous setState in effect
      setTimeout(() => setShowTimeout(false), 0);
    }
    
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [loading]);

  // Still loading
  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A0F1C] flex flex-col items-center justify-center">
        <div className="text-white text-xl mb-4">Chargement...</div>
        {showTimeout && (
          <div className="text-white/60 text-sm text-center px-4">
            <p>La connexion prend plus de temps que prévu.</p>
            <p className="mt-2">Vérifiez votre connexion internet.</p>
          </div>
        )}
      </div>
    );
  }

  // Network error but has token - allow access with warning (iOS resilience)
  if (networkError && token) {
    console.warn('Network error but token exists - allowing access');
    return children;
  }

  // Not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
